import { make } from 'vuex-pathify';
import { compact, filter, keys, keyBy, sortBy, uniq, values } from 'lodash';

const goals = keyBy(
    [
        {
            id: 1,
            title: 'Health',
            character: 'Billi',
            image: require('@/assets/poses/Trans-Poses_0001_Billi.png'),
            text: 'My goal is to have surgery within the next two years. Maybe you have a similar or different goal related to having a healthy body or mind?',
            visited: false
        },
        {
            id: 2,
            title: 'Education',
            character: 'Queenie',
            image: require('@/assets/poses/Trans-Poses_0002_Queenie.png'),
            text:
                'One of my goals is to finish my cosmetology certification in the next year. Do you have an educational goal, like finishing your GED, high school diploma, or going to college?',
            visited: false
        },
        {
            id: 3,
            title: 'Career',
            character: 'CJ',
            image: require('@/assets/poses/Trans-Poses_0000_CJ.png'),
            text:
                'I want to get a job in a place that accepts me for who I am and is respectful of my identity. Maybe your goal is to get a new job, or get a promotion, or start your own business, or become famous!',
            visited: false
        },
        {
            id: 4,
            title: 'Relationships',
            character: 'CJ',
            image: require('@/assets/poses/Trans-Poses_0000_CJ.png'),
            text:
                'I want to strengthen my relationships with the other members of my house. Do you have a goal that’s related to dating, friendship, or family?',
            visited: false
        },
        {
            id: 5,
            title: 'Finances',
            character: 'Queenie',
            image: require('@/assets/poses/Trans-Poses_0002_Queenie.png'),
            text: 'My goal is to start saving some money every month. What are your financial goals?',
            visited: false
        },
        {
            id: 6,
            title: 'Stability',
            character: 'Billi',
            image: require('@/assets/poses/Trans-Poses_0001_Billi.png'),
            text: 'One of my goals is to get my own apartment. Do you have a goal related to your housing or housing stability?',
            visited: false
        },
        {
            id: 7,
            title: 'Hobbies',
            character: 'Queenie',
            image: require('@/assets/poses/Trans-Poses_0002_Queenie.png'),
            text:
                'I have a goal related to my hobby of sewing. I want to make one new piece of clothing for each of my children! Maybe you have a goal that’s related to something you love doing!',
            visited: false
        }
    ],
    'id'
);
const goalsOrder = sortBy(keys(goals), k => parseInt(k));

const myGoals = keyBy(
    [
        {
            id: 1,
            category: '',
            text: '',
            steps: '',
            barrier: '',
            plan: '',
            shown: true
        },
        {
            id: 2,
            category: '',
            text: '',
            steps: '',
            barrier: '',
            plan: '',
            shown: false
        },
        {
            id: 3,
            category: '',
            text: '',
            steps: '',
            barrier: '',
            plan: '',
            shown: false
        },
        {
            id: 4,
            category: '',
            text: '',
            steps: '',
            barrier: '',
            plan: '',
            shown: false
        }
    ],
    'id'
);
const myGoalsOrder = sortBy(keys(myGoals), k => parseInt(k));
const myGoalsOptions = ['Health', 'Education', 'Career', 'Relationships', 'Finances', 'Stability', 'Hobbies', 'Other'];

const state = {
    title: 'Get Your Life!',
    complete: false,
    sticker: {
        text: '100 emoji',
        earned: false,
        image: require('@/assets/stickers/stickers_0001_100.png')
    },
    bonusSticker: false,
    trophy: {
        text: 'Trans pride flag',
        earned: false,
        image: require('@/assets/trophies/trophy_0003_flag.png')
    },
    goals,
    goalsOrder,
    myGoals,
    myGoalsOrder,
    myGoalsOptions
};
const getters = {
    ...make.getters(state),
    allGoalsVisited: state => {
        return 0 === filter(values(state.goals), { visited: false }).length;
    },
    myGoalsCount: state => {
        return filter(values(state.myGoals), { shown: true }).length;
    },
    myGoalsInvalid: state => {
        return (
            (state.myGoals['1'].shown && (!state.myGoals['1'].category || !state.myGoals['1'].text)) ||
            (state.myGoals['2'].shown && (!state.myGoals['2'].category || !state.myGoals['2'].text)) ||
            (state.myGoals['3'].shown && (!state.myGoals['3'].category || !state.myGoals['3'].text)) ||
            (state.myGoals['4'].shown && (!state.myGoals['4'].category || !state.myGoals['4'].text))
        );
    },
    myGoalsCategories: state => {
        return compact(uniq([state.myGoals['1'].category, state.myGoals['2'].category, state.myGoals['3'].category, state.myGoals['4'].category]));
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
